import { useQuery } from '@tanstack/react-query'
import { api } from './client'
import { queryKeys } from '../lib/query'
import type { Activity, EntityType } from '@1130-studio/shared'

// Types
interface ActivitiesFilters {
  entityType?: EntityType
  entityId?: string
  limit?: number
}

// Get activities list with filters
export function useActivities(filters: ActivitiesFilters = {}) {
  return useQuery({
    queryKey: queryKeys.activities.list(filters),
    queryFn: () => {
      const params = new URLSearchParams()
      if (filters.entityType) params.set('entityType', filters.entityType)
      if (filters.entityId) params.set('entityId', filters.entityId)
      if (filters.limit) params.set('limit', String(filters.limit))

      const queryString = params.toString()
      return api.get<Activity[]>(`/activities${queryString ? `?${queryString}` : ''}`)
    },
    enabled: !!filters.entityId,
  })
}
